import { DiscountBanner, FromPrice } from '@common/components/Price';
import WrappedSlider from '@common/components/WrappedSlider';
import { Link } from 'shared-routing';
import { Item } from 'shared-types/Common';
import { SpaEntityType } from 'shared-types/Spa';
import { SpaPackageLandingType } from 'shared-types/SpaPackage';
import React, { FC } from 'react';
import {
  EntityItem,
  EntityItemsRow,
  ItemDetails,
  ItemName,
  SliderWrapper,
} from './EntityPreviewRow.styles';
import { PREVIEW_ITEMS_QUANTITY } from '../constants';
import {
  BackgroundImgixWrapper,
  EntityImagePreview,
} from '@common/components/BackgroundImgixWrapper';

type EntityItemWrapperProps = {
  item: Item;
  route: string;
};

const EntityItemWrapper: FC<EntityItemWrapperProps> = ({ item, route }) => {
  return (
    <EntityItem key={item.id}>
      <Link route={route} params={{ id: item.id }}>
        <>
          <BackgroundImgixWrapper src={item.image?.url || null}>
            <EntityImagePreview background={!!item.image?.url} />
            <DiscountBanner discount={item.discount} />
          </BackgroundImgixWrapper>
        </>

        <ItemDetails>
          <ItemName>{item.name}</ItemName>

          {item.price ? <FromPrice {...item} /> : null}
        </ItemDetails>
      </Link>
    </EntityItem>
  );
};

type EntityPreviewRowProps = {
  route: string;
  items: (SpaPackageLandingType | SpaEntityType | Item)[];
  itemsInRow?: number;
};

const EntityPreviewRow: FC<EntityPreviewRowProps> = ({
  route,
  items,
  itemsInRow = PREVIEW_ITEMS_QUANTITY,
}) => (
  <EntityItemsRow>
    <SliderWrapper quantity={itemsInRow}>
      <WrappedSlider
        speed={300}
        variableWidth
        infinite={false}
        draggable={false}
        responsive={[
          {
            breakpoint: 1200,
            settings: {
              draggable: true,
              dots: false,
              arrows: false,
            },
          },
        ]}
      >
        {items.slice(0, itemsInRow).map((item) => (
          <EntityItemWrapper key={item.id} item={item as unknown as Item} route={route} />
        ))}
      </WrappedSlider>
    </SliderWrapper>
  </EntityItemsRow>
);

export default EntityPreviewRow;
